import React from 'react';
import PropTypes from 'prop-types';

import { CareersAtFiverrLink, LifeAtFiverrLink, SeeAllPositionsLink } from '../../CustomLinks';
import Teams from './components/Teams';
import Divider from './components/Divider';

import './styles.scss';

const Sidebar = ({ teams }) => (
    <div className="sidebar">
        <Teams teams={teams} />
        <Divider />
        <LifeAtFiverrLink />
        <CareersAtFiverrLink />
        <SeeAllPositionsLink isInHeader className="see-all-position-link" />
    </div>
);

Sidebar.propTypes = {
    teams: PropTypes.array,
};

Sidebar.defaultProps = {
    teams: [],
};

export default Sidebar;
